import { Box, Grid, Typography } from "@mui/material";
import LogoUploader from "../LogoUploader";
import QrColour from "./QrColour";
import BgColour from "./BgColour";


const Styling = () => {

    return(
        <Box sx={{marginTop: 2}}>
            <Typography variant="h6" gutterBottom>Styling</Typography>

            <Grid container spacing={1} sx={{marginTop: 2}}>
                <Grid item xs={2} md={4}>
                    <QrColour />
                </Grid>
                <Grid item xs={2} md={4}>
                    <BgColour />  
                </Grid>
                <Grid item xs={8} md={4}>
                    <LogoUploader />
                </Grid>
            </Grid>
        </Box>
    )

}

export default Styling;
